<template>
<div class="dashboard-panel">
    <portal target-el="#filter">
      <PrimaryFilter
        :menuOptions="menuList"
        :selectedCategory="selectedCategory"
        :hideSearchPopup="true"
      />
      </portal>
    <div class="d-flex">
      <MetricsList
        :data="metricsCount"
        :isListLoading="metricsCountLoading"
        @load-indent-list="getIndentList"
        @select-item="selectItem"
      />
      <div style="margin-left: 55%;">
        <EntityList
          :data="indentList"
          :isListLoadingCompleted="!metricsCountLoading && isListLoadingCompleted"
        />
      </div>
    </div>
</div>
</template>

<script>
import moment from 'moment';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import { menuList } from '@/constants/insight-tower-constants';
import EntityList from './entityList';
import MetricsList from './metricsList.vue';
import HeadPanel from '@common/components/HeadPanel';
import { interfaceEventType } from 'pando-constants';


export default {
  components: {
    HeadPanel,
    EntityList,
    PrimaryFilter,
    MetricsList,
  },

  data() {
    return {
      searchedParams: {},
      integrationList: [],
      category: null,
      entityDetails: null,
      menuList,
      integrationType: 1,
      enableSearchPopup: true,
      isListLoadingCompleted: true,
      integrationEvent: true,
      integrationDates: '',
      integrationColumn: '',
      emptyData: false,
      selectedEntity: {},
      interfaceEventType,
      indentList: [],
      metricsCount: {},
      metricsCountLoading: false,
    };
  },
  computed: {
    getCategorizedList() {
      return this.integrationList.map(integration => ({
        ...integration,
        updatedAt: moment(integration.updated_at).format('MMM Do YYYY  - hh:mm A'),
      }));
    },
    selectedCategory() {
      const path = this.$router.history.current.name;
      return this.menuList.find(menu => menu.id === path);
    },
  },
  async created() {
    await Promise.all([
      this.getMetricsCount(),
      this.getIndentList(),
    ]);
  },
  methods: {
    async getIndentList(data = {}) {
      try {
        this.isListLoadingCompleted = false;
        const queryParams = data.queryParams || 'status=indented';
        const endPoint = data.endPoint || 'order/filtered-indents';
        const result = await this.$store.dispatch(
          'order/getCTIndentList',
          { queryParams, endPoint },
        );
        if (result && result.length) {
          this.indentList = result;
          this.emptyData = false;
        } else {
          this.indentList = [];
        }
        this.isListLoadingCompleted = true;
      } catch (error) {
        this.$error({ message: this.$getErr('APP_CATCH_ERR') });
      }
    },
    async getMetricsCount() {
      try {
        this.metricsCountLoading = true;
        const endPoints = ['order/status-count', 'order/data-missing-count', 'order/breach-count'];
        // eslint-disable-next-line no-restricted-syntax
        for (const endPoint of endPoints) {
          // eslint-disable-next-line no-await-in-loop
          const result = await this.$store.dispatch(
            'order/getCTIndentMetricsCount',
            { endPoint },
          );
          if (result) {
            this.metricsCount = {
              ...this.metricsCount,
              ...result,
            };
          }
        }
        this.metricsCountLoading = false;
      } catch (err) {
        this.$error({ message: this.$getErr('APP_CATCH_ERR') });
      }
    },
    loadSearchFromSession() {
      const sessionSearchParamsJSON = localStorage.getItem(`${this.$route.name}-search-popup`) || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      this.searchedParams = Object.assign({}, this.searchedParams, sessionSearchParams);
    },
    saveSearchToSession() {
      const sessionSearch = JSON.stringify(this.searchedParams);
      localStorage.setItem(`${this.$route.name}-search-popup`, sessionSearch);
    },
    async selectItem(entity) {
      this.selectedEntity = entity;
    },
  },
};
</script>
